import React from "react";
import Modal from "../common/modal";
import Button from "../common/button";

const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Delete",
  message = "Are you sure you want to delete",
  itemName = "",
  isLoading = false,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
    >
      <div style={{ padding: "10px 2px" }}>
        <p style={{ margin: 0, color: "#333", fontSize: "16px", lineHeight: "1.5" }}>
          {message}{" "}
          {itemName ? (
            <strong style={{ color: "#ef4444" }}>{itemName}</strong>
          ) : (
            "this item"
          )}?
        </p>
        <p style={{ margin: "8px 0 0", color: "#666", fontSize: "13px" }}>
          This action is permanent and will remove it from the database.
        </p>
      </div>

        <Button onClick={onClose} className="CancelButton">Cancel</Button>
        <Button 
          onClick={onConfirm} 
          disabled={isLoading}
          className="CcommonButton"
        >
          {isLoading ? "Deleting..." : "Delete"}
        </Button>
    </Modal>
  );
};

export default DeleteModal;
